import React, { useEffect, useState } from "react";
import {
  Box,
  Typography,
  IconButton,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Paper,
  Tooltip,
  Button,
  TextField,
  CircularProgress,
  Alert,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from "@mui/material";

import AddIcon from "@mui/icons-material/Add";
import EditNoteOutlinedIcon from "@mui/icons-material/EditNoteOutlined";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";

import KurumModal from "../components/institution/KurumModal";
import { useApi } from "../utils/api";

const Institution = () => {
  const http = useApi();

  const [kurumlar, setKurumlar] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [search, setSearch] = useState("");

  // modal
  const [modalOpen, setModalOpen] = useState(false);
  const [editingKurum, setEditingKurum] = useState(null);

  // silme
  const [deleteTarget, setDeleteTarget] = useState(null);

  const fetchKurumlar = async () => {
    setLoading(true);
    try {
      const data = await http.get("/kurumlar");
      setKurumlar(Array.isArray(data) ? data : []);
    } catch {
      setError("Kurumlar yüklenemedi.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchKurumlar();
  }, []);

  const filteredKurumlar = kurumlar.filter((k) =>
    k.kurum_adi.toLowerCase().includes(search.toLowerCase())
  );

  return (
    <Box>
      {/* ÜST BAR */}
      <Box display="flex" justifyContent="space-between" mb={2}>
        <Box>
          <Typography variant="h5" fontWeight={600}>Kurumlar</Typography>
          <Typography variant="body2" color="text.secondary">
            Sistemde kayıtlı kurumları yönetin
          </Typography>
        </Box>

        <Button
          variant="contained"
          startIcon={<AddIcon />}
          sx={{ ml: 1 }}
          onClick={() => {
            setEditingKurum(null);
            setModalOpen(true);
          }}
        >
          Kurum Ekle
        </Button>
      </Box>

      <TextField
        size="small"
        fullWidth
        placeholder="Kurum adı ara..."
        sx={{ mb: 2 }}
        value={search}
        onChange={(e) => setSearch(e.target.value)}
      />

      {error && <Alert severity="error">{error}</Alert>}

      <Paper>
        <Table>
          <TableHead sx={{ bgcolor: "#f5f5f5" }}>
            <TableRow>
              {["Kurum Adı", "Şirket Ünvanı", "Vergi No", "TC", "Adres", "İşlemler"]
                .map((h) => (
                  <TableCell key={h} align="center" sx={{ fontWeight: 600 }}>
                    {h}
                  </TableCell>
                ))}
            </TableRow>
          </TableHead>

          <TableBody>
            {loading && (
              <TableRow>
                <TableCell colSpan={6} align="center">
                  <CircularProgress size={20} />
                </TableCell>
              </TableRow>
            )}

            {!loading &&
              filteredKurumlar.map((k) => (
                <TableRow key={k.id} hover>
                  <TableCell align="center">{k.kurum_adi}</TableCell>
                  <TableCell align="center">{k.sirket_unvani}</TableCell>
                  <TableCell align="center">{k.vergi_no}</TableCell>
                  <TableCell align="center">{k.tc}</TableCell>
                  <TableCell align="center">{k.adres || "-"}</TableCell>
                  <TableCell align="center">
                    <Tooltip title="Düzenle">
                      <IconButton
                        size="small"
                        onClick={() => {
                          setEditingKurum(k);
                          setModalOpen(true);
                        }}
                      >
                        <EditNoteOutlinedIcon />
                      </IconButton>
                    </Tooltip>

                    <Tooltip title="Sil">
                      <IconButton
                        size="small"
                        color="error"
                        onClick={() => setDeleteTarget(k)}
                      >
                        <DeleteOutlineIcon />
                      </IconButton>
                    </Tooltip>
                  </TableCell>
                </TableRow>
              ))}
          </TableBody>
        </Table>
      </Paper>

      <KurumModal
        open={modalOpen}
        initialData={editingKurum}
        onClose={() => setModalOpen(false)}
        onSuccess={() => {
          setModalOpen(false);
          fetchKurumlar();
        }}
      />

      <Dialog open={!!deleteTarget} onClose={() => setDeleteTarget(null)}>
        <DialogTitle>Kurum Silinsin mi?</DialogTitle>
        <DialogContent>
          <Typography>
            <strong>{deleteTarget?.kurum_adi}</strong> silinecek.
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setDeleteTarget(null)}>Vazgeç</Button>
          <Button
            color="error"
            variant="contained"
            onClick={async () => {
              await http.del(`/kurumlar/${deleteTarget.id}`);
              setDeleteTarget(null);
              fetchKurumlar();
            }}
          >
            Sil
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default Institution;
